import React from 'react';
// import './Hero.css';
import JacekShowcase from './nft';
import Bodyimage from './bodyimage';
// import LogoChanger from './logochanger';



function Hero() {
  return (
    <div className="hero">
      <Bodyimage/>
      <h1 className="jecak-nft-header"> Surfing Farcaster and Beyond: JECAK NFTs</h1>
      <div className="main-container">
      <JacekShowcase/>
        {/* <Nft/> */}
        {/* <LogoChanger/> */}

      </div>
    </div>
  );
}

export default Hero;

